import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import extend from 'lodash/extend';
import authUtil from '../../utils/auth_util';
import cachingService from '../../services/caching_service';
import request from '../../utils/request_util';
import Base from '../base_model';
import log from '../../services/logger_service';

export default class CategoryAllFeed extends Base {
  static fetch({ category, page, tag }, store, isTag) {
    const pageParams = page ? `&page=${page}` : '';
    const tagStr = isTag ? `&tag=${tag}` : '';
    const total = 20;
    const state = store.getState();
    const cacheEnabled = get(state, 'config.cacheEnabled');
    const cacheNamespace = get(state, 'config.cacheNamespace');
    const cacheExpire = get(state, 'config.cacheExpire');
    const site = get(state, 'config.site');
    const host = get(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
    const protocol = get(state, 'config.protocol') || 'https://';
    const options = {};
    let abtest = get(state, 'config.abtest');
    if (abtest) {
      abtest = `?abtest=${abtest}`;
    }

    // api has auth in beta
    if (get(state, 'config.authEnabled')) {
      extend(options, authUtil(state));
    }

    const isNews = category === 'news';
    const url = `v2/posts-category-slug/${site}/${category}?total=${total}${pageParams}${
      isNews ? '&with_body=true' : ''
    }${tagStr}`;
    const cacheKeyUrl = `${protocol}${host}/api/${url}`;
    const cacheKey = `${cacheNamespace}:${cacheKeyUrl}${abtest}`;

    if (!cacheEnabled) {
      return request.getAsync(cacheKeyUrl, options);
    }

    if (!canUseDOM) {
      log.info(`Requesting: ${cacheKeyUrl} from model.`);
    }
    return cachingService.getAsync(cacheKey).then(function fromCache(cacheRes) {
      if (cacheRes) {
        return Promise.resolve(JSON.parse(cacheRes));
      }

      return request
        .getAsync(cacheKeyUrl, options)
        .then(function fetchSuccess(resp) {
          cachingService.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
    });
  }
}
